
import { Wine } from "../types";

const CLIENT_ID = "762541131288-cl0k87j2mgb6pjcc0h3sq882q79u8onc.apps.googleusercontent.com"; 
const SCOPES = "https://www.googleapis.com/auth/drive.file";
const DISCOVERY_DOC = "https://www.googleapis.com/discovery/v1/apis/drive/v3/simple";

let tokenClient: any = null;
let gapiInited = false;
let gsisInited = false;

export const loadGoogleScripts = (): Promise<void> => {
  return new Promise((resolve) => {
    const scriptGapi = document.createElement('script');
    scriptGapi.src = "https://apis.google.com/js/api.js";
    scriptGapi.async = true;
    scriptGapi.defer = true;
    scriptGapi.onload = () => {
      window.gapi.load('client', async () => {
        await window.gapi.client.init({});
        gapiInited = true;
        checkInit();
      });
    };
    document.body.appendChild(scriptGapi);

    const scriptGsi = document.createElement('script');
    scriptGsi.src = "https://accounts.google.com/gsi/client";
    scriptGsi.async = true;
    scriptGsi.defer = true;
    scriptGsi.onload = () => {
      tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: SCOPES,
        callback: '',
      });
      gsisInited = true;
      checkInit();
    };
    document.body.appendChild(scriptGsi);

    function checkInit() {
      if (gapiInited && gsisInited) resolve();
    }
  });
};

export const authenticate = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!tokenClient) return reject("Google Identity Services non caricato.");
    tokenClient.callback = async (resp: any) => {
      if (resp.error !== undefined) { reject(resp); return; }
      resolve(resp.access_token);
    };
    tokenClient.requestAccessToken({ prompt: 'consent' });
  });
};

export const syncToDrive = async (profileName: string, data: any): Promise<boolean> => {
  try {
    const fileName = `divino_backup_${profileName.replace(/\s+/g, '_')}.json`;
    const token = window.gapi.client.getToken()?.access_token;
    if (!token) return false;

    const listRes = await fetch(`https://www.googleapis.com/drive/v3/files?q=name='${fileName}' and trashed=false`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const listData = await listRes.json();
    const files = listData.files;
    
    const content = JSON.stringify(data);
    const metadata = { name: fileName, mimeType: 'application/json' };

    if (files && files.length > 0) {
      const fileId = files[0].id;
      await fetch(`https://www.googleapis.com/upload/drive/v3/files/${fileId}?uploadType=media`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: content,
      });
    } else {
      const form = new FormData();
      form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
      form.append('file', new Blob([content], { type: 'application/json' }));

      await fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: form,
      });
    }
    return true;
  } catch (err) {
    console.error('Sync Error:', err);
    return false;
  }
};

export const fetchFromDrive = async (profileName: string): Promise<any> => {
  try {
    const fileName = `divino_backup_${profileName.replace(/\s+/g, '_')}.json`;
    const token = window.gapi.client.getToken()?.access_token;
    if (!token) return null;

    const listRes = await fetch(`https://www.googleapis.com/drive/v3/files?q=name='${fileName}' and trashed=false`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const listData = await listRes.json();
    const files = listData.files;

    if (files && files.length > 0) {
      const fileId = files[0].id;
      const res = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      return await res.json();
    }
    return null;
  } catch (err) {
    console.error('Fetch Error:', err);
    return null;
  }
};
